import user_management_route from "./modules/user_management_route";
import listing_oversight_route from "./modules/listing_oversight_route";
import listing_report_route from "./modules/listing_report_route";
import deal_monitoring_route from "./modules/deal_monitoring_route";
import payout_control_route from "./modules/payout_control_route";
import credit_score_route from "./modules/credit_score_route";
import review_route from "./modules/review_route";
import financial_ledger_route from "./modules/financial_ledger_route";
import subscription_management_route from "./modules/subscription_management_route";
import listing_boost_route from "./modules/listing_boost_route";
import my_profile_route from "./modules/my_profile_route";
import dashboard_route from "./modules/dashboard_route";
import witness_route from "./modules/witness_route";
import support_chat_route from "./modules/support_chat_route";

const routes = [
    ...user_management_route,
    ...listing_oversight_route,
    ...listing_report_route,
    ...deal_monitoring_route,
    ...payout_control_route,
    ...credit_score_route,
    ...review_route,
    ...financial_ledger_route,
    ...subscription_management_route,
    ...listing_boost_route,
    ...witness_route,
    ...support_chat_route,
    ...my_profile_route,
    ...dashboard_route,
];

export default routes;
